import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = { class: "related-summary-item__image-wrapper" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "related-summary-item__description" }
const _hoisted_5 = { class: "related-summary-item__title" }
const _hoisted_6 = { class: "related-summary-item__author" }
const _hoisted_7 = ["innerHTML"]

import type { RelatedSummaryItem } from '@/models/interfaces'
import { computed } from 'vue'
import BookFallbackCover from '@/app/components/book/card/BookFallbackCover.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'RelatedSummaryItem',
  props: {
    item: {}
  },
  setup(__props: any) {

const props = __props

// We are not using router-link for the url here, because we're rendering the
// AdditionalInformationBlock as HTML and hence it doesn't exist
// github.com/shortformhq/main/blob/bb5c30ccf1b71510e29289e8d097e9e38701cc09/frontend/src/app/components/doc/reading/Chapter.vue#L64-L85
const urlSlug = computed(() => {
  // We return the full url from backend, stripping away the hostname here
  return props.item.url.replace('https://www.shortform.com', '')
})

// AI books don't have cover images: instead, it's returned as 'https:None'.
// This is a hotfix solution: AI books shouldn't even appear in the
// related summaries section.
const hasThumbnail =
  props.item.thumbnail && props.item.thumbnail !== 'https:None'

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    href: urlSlug.value,
    class: "related-summary-item"
  }, [
    _createElementVNode("div", _hoisted_2, [
      (_unref(hasThumbnail))
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "related-summary-item__image",
            src: __props.item.thumbnail
          }, null, 8, _hoisted_3))
        : (_openBlock(), _createBlock(BookFallbackCover, {
            key: 1,
            class: "related-summary-item__fallback-image",
            title: __props.item.title,
            subtitle: __props.item.author
          }, null, 8, ["title", "subtitle"]))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("h5", _hoisted_5, _toDisplayString(__props.item.title), 1),
      _createElementVNode("h6", _hoisted_6, _toDisplayString(__props.item.author), 1),
      _createElementVNode("div", {
        class: "related-summary-item__blurb",
        innerHTML: __props.item.blurb
      }, null, 8, _hoisted_7)
    ])
  ], 8, _hoisted_1))
}
}

})